import React, { useEffect } from "react";
import DistributorBalance from "../../../ResuableCompoment/DistributorBalance";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ImageCarousel from "../../../ResuableCompoment/ImageCarousel";


const DistributorDashboard = () => {
    const navigate = useNavigate();
    const rolebased = useSelector(
        (state) => state.auth.employeeDetails?.role
    );

    useEffect(() => {
        if (rolebased !== "DISTRIBUTOR") {
            navigate("/");
        }
    }, [rolebased, navigate]);

    return (
        <div className="min-h-screen">
            <DistributorBalance />


            <div className="mt-8 sm:mt-10 md:mt-12 mb-8">
                <ImageCarousel />
            </div>
        </div>
    );

};

export default DistributorDashboard;
